import React, { useEffect } from 'react';
import { Calculator, ExternalLink } from 'lucide-react';
import { Card, CardContent, Button } from '@plvplus/core';

export const PriPlusRedirect: React.FC = () => {
  useEffect(() => {
    // In a real implementation, this would redirect to the PRI+ module
    // For now, we'll show a placeholder
  }, []);

  const handleOpenPriPlus = () => {
    // In production, this would open the PRI+ module
    // For development, we can redirect to the PRI+ dev server
    window.open('http://localhost:3001', '_blank');
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Module PRI+
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Calcul des prix de revient pour l'industrie PLV
        </p>
      </div>

      <Card variant="elevated" className="max-w-md mx-auto">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 bg-primary-100 dark:bg-primary-900/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <Calculator className="h-8 w-8 text-primary-600 dark:text-primary-400" />
          </div>
          
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            Ouvrir PRI+
          </h3>
          
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Le module PRI+ s'ouvrira dans un nouvel onglet pour une expérience optimale.
          </p>

          <Button onClick={handleOpenPriPlus} className="w-full">
            <ExternalLink className="h-4 w-4 mr-2" />
            Accéder à PRI+
          </Button>

          <div className="mt-4 text-xs text-gray-500 dark:text-gray-400">
            <p>Port de développement: 3001</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
